<template>
    <div class="-mt-2 z-0 pt-4 overflow-y-auto border border-[#E7E5E4] rounded-b-[16px] bg-white">
        <div class="h-full relative">
            <div class="border-b border-[#E7E5E4] px-2 min-[320px]:px-4">
                <button class="text-player-list-item text-[14px] font-bold leading-[22px] p-2 border-b-2 border-player-list-item -mb-[1px]" aria-hidden="true">{{ __('Episodes') }}</button>
            </div>

            <ul class="px-2 xs:px-4 pt-2 pb-6" :title="__('Episodes')" :aria-label="__('Episodes')">
                <li v-for="(item, index) in playlist" :title="item.title" :aria-label="item.title" @click="emit('play-track', index)"
                        class="w-full py-2 px-2 text-player-list-item hover:opacity-50 transition cursor-pointer"
                    :class="{
                        'text-player-accent': isPlaying(index) || isCurrent(index),
                    }"
                >
                    <div class="flex flex-row items-center w-full">
                        <div class="hidden min-[320px]:block">
                            <PauseCircle v-if="isPlaying(index)" class="fill-player-list-item" />
                            <PlayCircle v-else :class="{ 'fill-player-accent': isCurrent(index) }" class="fill-player-list-item" />
                        </div>

                        <p class="min-[320px]:ml-2 text-left text-[14px] font-normal">
                            <span v-if="item.season">S{{ item.season }} / </span>
                            <span v-if="item.episode">E{{ item.episode }}</span>
                            <span class="ml-1" v-text="item.title"/>
                        </p>

                        <p class="text-right text-[14px] font-normal ml-auto opacity-50" v-text="formatTime(item.audio.duration)"/>
                    </div>

                    <div ref="chapters" v-if="isCurrent(index) && item.chapters?.length" class="flex flex-row items-center space-x-2 min-[320px]:pl-6 mt-3 border-b border-[#E7E5E4] pb-5 overflow-x-auto">
                        <button v-for="(chapter, chapterIndex) in item.chapters ?? []"
                            class="border border-[#E7E5E4] text-player-list-item rounded-[6px] py-1 px-2.5 text-[13px] font-normal hover:border-[#EB5AA9] transition whitespace-nowrap"
                            :class="{
                                'border-player-accent': currentChapter === chapterIndex,
                            }"
                            :data-chapter="chapterIndex"
                            @click.stop="emit('play-chapter', chapter.from_time)"
                        >
                            <span class="font-bold">{{ formatTime(chapter.from_time) }}</span> <span class="truncate">{{ chapter.title }}</span>
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import {formatTime} from "../useWaveform";
import __ from "../helpers";
import PlayCircle from "./PlayCircle.vue";
import PauseCircle from "./PauseCircle.vue";
import { ref, watch } from "vue";

const props = defineProps({
    playlist: Array,
    currentTrack: Number,
    isPlaying: Boolean,
    currentChapter: Number,
})

const emit = defineEmits(['play-track', 'play-chapter'])

watch(() => props.currentTrack, () => {
    scrollToChapter(props.currentChapter)
})

watch(() => props.currentChapter, () => {
    scrollToChapter(props.currentChapter)
})

function isCurrent(index) {
    return props.currentTrack === index
}

function isPlaying (index) {
    return isCurrent(index) && props.isPlaying
}

const chapters = ref(null)

function scrollToChapter(index) {
    if (!chapters.value && !chapters.value?.length) {
        return
    }

    // Find chapter within chapters ref by button[data-chapter]
    const chapter = chapters.value[0]?.querySelector(`button[data-chapter="${index}"]`)

    if (chapter) {
        // Scroll chapters to left site of this chapter
        chapters.value[0].scrollTo({
            left: chapter.offsetLeft - chapters.value[0].offsetLeft,
            behavior: 'smooth',
        })
    }
}

</script>
